import * as Icons from "lucide-react";

const ICON = (name) => {
  const C = Icons[name] || Icons.Sparkles;
  return <C className="h-6 w-6" strokeWidth={1.3} />;
};

export default function Why({ data }) {
  const label = data?.label || "Why couples choose Mostash";
  const headline = data?.headline || "Most couples plan a wedding once. We've spent years planning them.";
  const intro = data?.intro || "";
  const features = data?.features || [];

  // Style the headline: italicise second sentence in gold.
  const renderHeadline = () => {
    const parts = headline.split(/\.\s+/);
    if (parts.length >= 2) {
      const first = parts.slice(0, -1).join(". ") + ".";
      const last = parts[parts.length - 1];
      return (
        <>
          {first}<br />
          <em className="italic font-light text-gold not-italic">{last}</em>
        </>
      );
    }
    return headline;
  };

  return (
    <section id="about" data-testid="why-section" className="bg-ivory py-20 md:py-32">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="grid grid-cols-12 gap-8 mb-14 md:mb-20">
          <div className="col-span-12 md:col-span-7">
            <div className="reveal flex items-center gap-3 mb-5">
              <span className="h-px w-10 bg-gold" />
              <span className="eyebrow">{label}</span>
            </div>
            <h2
              data-testid="why-headline"
              className="reveal font-display text-[2.25rem] leading-[1.05] sm:text-5xl md:text-6xl tracking-tight text-charcoal"
            >
              {renderHeadline()}
            </h2>
          </div>
          <div className="col-span-12 md:col-span-5 md:pl-6 self-end">
            <p className="reveal text-base md:text-lg font-light text-charcoal/75 leading-relaxed">
              {intro}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {features.map((f, i) => (
            <article
              key={f.title}
              data-testid={`why-feature-${i}`}
              className="reveal group relative bg-white border border-beige p-7 md:p-10 transition-all duration-500 hover:bg-sage/30 hover:border-teal-600/30"
            >
              <div className="text-teal-600 mb-5">{ICON(f.icon)}</div>
              <h3 className="font-display text-2xl md:text-3xl text-charcoal leading-snug">
                {f.title}
              </h3>
              <p className="mt-4 text-charcoal/70 font-light leading-relaxed">{f.description}</p>
              <div className="mt-6 h-px w-10 bg-gold/70 group-hover:w-20 transition-all duration-500" />
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
